<template>
  <SingleSQ
    :questionData="questionData"
    :btnWidth="500"
    :oneOption="true"
    :pendingOption="false"
    :sq_numberData="'sq_fiftyTwoData'"
    :sqOptions="[38]"
    @editQuestion="editQuestion"
    @deleteQuestion="deleteQuestion"
    @checkIfHistoryModeContinues="checkIfHistoryModeContinues"
    @reduceDecreasing="reduceDecreasing"
    @handleProgress="handleProgress">
  </SingleSQ>
</template>

<script>
import SingleSQ from '@/components/savings/blocks/SingleSQ'
import { singleQuesMethods } from '@/mixins/singleQuesMethods'

export default {
  name: 'SQuesFiftyTwo',
  components: {
    SingleSQ
  },
  props: {
    questionData: Object
  },
  methods: {
    handleProgress (value) {
      if (value === 1) {
        this.$emit('handleProgress', 94)
      } else if (value === 3) {
        this.$emit('handleProgress', 52)
      }
    }
  },
  mixins: [singleQuesMethods]
}
</script>
